import { useEffect, useRef, useState } from 'react';

interface UsePageTimeoutOptions {
    isEnabled?: boolean;
    timeoutMs?: number;
}

export function usePageTimeout({
    isEnabled = false,
    timeoutMs = 30000,
}: UsePageTimeoutOptions = {}) {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const warningTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const [showTimeoutWarning, setShowTimeoutWarning] = useState(false);

    useEffect(() => {
        if (isEnabled) {
            warningTimeoutRef.current = setTimeout(() => {
                setShowTimeoutWarning(true);
            }, timeoutMs - 10000);

            timeoutRef.current = setTimeout(() => {
                console.warn(
                    'Page loader timeout reached. Clearing site data and reloading...',
                );
                try {
                    localStorage.clear();

                    sessionStorage.clear();

                    document.cookie.split(';').forEach(c => {
                        const eqPos = c.indexOf('=');
                        const name = eqPos > -1 ? c.substr(0, eqPos) : c;
                        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
                        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
                    });

                    if ('indexedDB' in window && indexedDB.databases) {
                        indexedDB
                            .databases()
                            .then(databases => {
                                databases.forEach(db => {
                                    if (db.name) {
                                        indexedDB.deleteDatabase(db.name);
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                } catch (error) {
                    console.error('Error clearing site data:', error);
                }

                window.location.reload();
            }, timeoutMs);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            if (warningTimeoutRef.current) {
                clearTimeout(warningTimeoutRef.current);
            }
            setShowTimeoutWarning(false);
        };
    }, [isEnabled, timeoutMs]);

    return { showTimeoutWarning };
}
